import React, { useState } from "react";
import axios from "axios";
import { Card, Col, Row, Spinner } from "react-bootstrap";

const HistoricalImmunizationReportConsent = ({
  initial_consent_revoked_on: initialConsentRevokedOn,
  test_group_id: testGroupId,
  test_group_user_id: testGroupUserId,
}) => {
  const [consentRevokedDate, setConsentRevokedDate] = useState(initialConsentRevokedOn);
  const [loading, setLoading] = useState(false);

  const handleToggle = async () => {
    if (loading) return;
    setLoading(true);
    try {
      const response = await axios.put(`/api_v2/test_groups/${testGroupId}/schools/student_profiles/${testGroupUserId}/toggle_consent_revoked_on`);
      if (response.data.success) {
        setConsentRevokedDate(response.data.sdiis_consent_revoked_on);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="my-4">
      <h5 className="my-3">
        Report historical immunizations to SDIIS
      </h5>
      <Card>
        <Card.Body>
          <p className="text-muted">
            Please check the box below if a parent or guardian has revoked consent to report historical immunizations to the South Dakota Immunization Information System (SDIIS).
          </p>
          <Row>
            <Col xl={8} md={12} >
              <div
                className="d-flex pointer"
                onClick={handleToggle}
                style={{ opacity: loading ? 0.5 : 1, pointerEvents: loading ? 'none' : 'auto' }}
              >
                {loading ? (
                  <Spinner animation="border" size="sm" className="me-2" />
                ) : (
                  <input
                    className="form-check-input me-2 pointer"
                    type="checkbox"
                    checked={!!consentRevokedDate}
                    readOnly
                  />
                )}
                <h5>{consentRevokedDate ? "Consent revoked" : "Revoke consent"}</h5>
              </div>
              {consentRevokedDate && (
                <>
                  <div className="text-muted">
                    Consent revoked on: {new Date(consentRevokedDate).toLocaleDateString()}
                  </div>
                  <div
                    className="p-3 my-3"
                    style={{
                      backgroundColor: "#F3E2E3",
                      borderRadius: "5px",
                      color: "var(--bs-danger)",
                    }}
                  >
                    Parent has opted out from reporting their child's immunizations to the state.
                  </div>
                </>
              )}
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </div>
  );
};

export default HistoricalImmunizationReportConsent;